<!--
 * @Description:
 * @Date: 2020-07-16 17:52:16
-->
<template>
  <div class="bi-combination" v-if="ds">
    <div style="margin-top: 75px;" class="bi-export-item">
      <lBiTitle title="报告亮点"></lBiTitle>
      <div class="bi-combination-age ">
        <div class="bi-combination-age-item">
          <div class="bi-combination-age-box">
            <div class="bi-combination-age-echarts">
              <Echarts
                :echartOption="ds.age.echart[0].echartOption"
                :echartStyle="ds.age.echart[0].echartStyle"
                :echartType="ds.age.echart[0].echartType"
              ></Echarts>
            </div>
            <p class="bi-combination-p">项目执行人年龄区间</p>
          </div>
          <div class="bi-combination-age-label" style="margin-top:25px;">
            <div
              class="bi-combination-age-label-item"
              v-for="(item, index) in ageLabel.slice(0, 3)"
              :key="index"
            >
              <lHexagonSvg :color="item.itemStyle.normal.color"></lHexagonSvg>
              <span>{{ item.name }}</span>
            </div>
          </div>
          <div class="bi-combination-age-label">
            <div
              class="bi-combination-age-label-item"
              v-for="(item, index) in ageLabel.slice(3)"
              :key="index"
            >
              <lHexagonSvg :color="item.itemStyle.normal.color"></lHexagonSvg>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="bi-combination-age-item">
          <div class="bi-combination-age-box">
            <div class="bi-combination-age-echarts">
              <lCustomChartsSex :chartData="genderData"></lCustomChartsSex>
              <!-- <Echarts
                :echartOption="ds.gender.echart[0].echartOption"
                :echartStyle="ds.gender.echart[0].echartStyle"
                :echartType="ds.gender.echart[0].echartType"
              ></Echarts>-->
            </div>
            <p class="bi-combination-p">项目执行人性别比例</p>
          </div>
          <div class="bi-combination-age-label" style="margin-top:25px;">
            <div
              class="bi-combination-age-label-item"
              v-for="(item, index) in genderData"
              :key="index"
            >
              <lHexagonSvg :color="item.color"></lHexagonSvg>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="bi-text-block">
          <p>根据统计信息：</p>
          <p>{{ tongji }}</p>
        </div>
      </div>
    </div>
    <div class="bi-combination-audit bi-export-item">
      <p class="bi-combination-p">任务审核状态</p>
      <div class="bi-combination-audit-d">
        <div class v-for="(item, index) in ds.audit.table.data" :key="index">
          <lCustomChartsAudit
            :value="item.v"
            :total="ds.audit.total"
          ></lCustomChartsAudit>
          <div class="bi-combination-audit-d-info">
            <p>{{ item.d }}：{{ item.v }}条</p>
            <p>{{ item.b }}</p>
          </div>
        </div>
      </div>
      <div class="bi-text-block">
        <p>根据统计信息：</p>
        <p>{{ auditTongji }}</p>
      </div>
    </div>
    <div class="bi-combination-mission bi-export-item">
      <p class="bi-combination-p">项目参与人执行任务表</p>
      <Echarts
        :echartOption="ds.implement.echart[0].echartOption"
        :echartStyle="ds.implement.echart[0].echartStyle"
        :echartType="ds.implement.echart[0].echartType"
      ></Echarts>
      <div class="bi-text-block">
        <p>所有项目参与人中：</p>
        <p>
          <span v-for="(item, index) in ds.implement.table.data" :key="index">
            完成任务数为{{ item.d }}单，总计有{{ item.v }}人，占比：{{
              item.b
            }}；
          </span>
        </p>
      </div>
      <!-- <Table :table="ds.implement.table"></Table> -->
    </div>
  </div>
</template>

<script>
import Echarts from './Echarts/Index';
import lHexagonSvg from './common/hexagonSvg';
import lBiTitle from './common/title';
import lCustomChartsSex from './customCharts/sex';
import lCustomChartsAudit from './customCharts/audit';

export default {
  props: {
    combinationData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  watch: {
    combinationData() {}
  },
  data() {
    return {};
  },
  components: {
    lBiTitle,
    lHexagonSvg,
    lCustomChartsSex,
    lCustomChartsAudit,
    Echarts
  },
  computed: {
    tongji() {
      try {
        const d1 = this.ageLabel.reduce((pre, cur) => {
          pre.push(cur.name.replace(':', '占比'));
          return pre;
        }, []);
        const d2 = this.genderData.reduce((pre, cur) => {
          pre.push(cur.name.replace(':', '占比'));
          return pre;
        }, []);
        return `项目执行人中${d1.join('，')}。其中${d2.join('，')}`;
      } catch (error) {
        return '';
      }
    },
    auditTongji() {
      try {
        const arr = this.ds.audit.table.data.reduce((pre, cur) => {
          const { b, d, v } = cur;
          pre.push(`${d}任务数${v}条，占比${b}`);
          return pre;
        }, []);
        return `本月度任务中，${arr.join('；')}。`;
      } catch (error) {
        return '';
      }
    },
    genderData() {
      return this.ds.gender.data
        .map((item, index) => {
          item['color'] = ['#2722FF', '#ECBC27'][index];
          return item;
        })
        .reverse();
    },
    ageLabel() {
      let arr = [];
      try {
        arr = this.ds.age.echart[0].echartOption.series[2].data;
      } catch (err) {
        console.error(err);
      }
      return arr.filter(item => item.name);
    },
    ds() {
      return this.combinationData && this.combinationData.age
        ? this.combinationData
        : null;
    }
  },
  methods: {},
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.bi-combination {
  max-width: 1200px;
  margin-bottom: 16px;

  &-title {
    font-size: 28px;
    font-weight: bold;
    color: #000000;
    line-height: 1;
    margin-bottom: 36px;
  }
  &-age {
    background-color: #fff;
    padding: 40px;
    padding-bottom: 32px;
    margin-bottom: 13px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    &-echarts {
      width: 400px;
      height: 140px;
      overflow: hidden;
      display: flex;
      justify-content: center;
    }
    &-item {
      width: 48%;
    }
    &-box {
      width: 100%;
      height: 180px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      & > p {
        width: 216px;
        height: 34px;
        border: 2px solid #666666;
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        line-height: 32px;
        text-align: center;
      }
    }
    &-label {
      display: flex;
      font-size: 13px;
      color: #333333;
      line-height: 1;
      align-items: center;
      justify-content: space-around;
      &-item {
        margin-bottom: 20px;
        display: flex;
        align-content: center;
        justify-content: center;
        span {
          line-height: 16px;
          word-break: keep-all;
        }
      }
    }
  }
  &-audit {
    background-color: #fff;
    padding: 40px;
    margin-bottom: 13px;
    &-d {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &-info {
        p {
          color: #434343;
          &:first-child {
            font-size: 14px;
            line-height: 1;
          }
          &:last-child {
            font-size: 24px;
            line-height: 1;
            margin-top: 22px;
          }
        }
      }
    }
    .bi-combination-p {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 45px;
    }
  }
  &-mission {
    background-color: #fff;
    padding: 40px;
    .bi-combination-p {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 40px;
    }
  }
  &-p {
  }
  .bi-text-block {
    width: 100%;
    margin-top: 40px;
    text-align: left;
    & > p {
      display: inline;
      line-height: 36px;
      &:first-child {
        flex-shrink: 0;
        letter-spacing: 1px;
      }
      &:last-child {
        flex-shrink: 1;
        text-align: left;
        letter-spacing: 2px;
      }
    }
  }
}
</style>
